// extracted by mini-css-extract-plugin
module.exports = {"back-button":"BackButton_back-button__3BlYC","back-button__chevron":"BackButton_back-button__chevron__3TGrc"};